<template>
    <div class="row">
        <template>
            <div class="text-center ma-2" style="margin-top: 15%; margin-right: 15%; z-index: 1500;">
                <v-snackbar
                        v-model="showSnackBar"
                         :timeout="snackUpdatedTimeOut">
                    <span :color="snackUpdatedColor">{{ snackText }}</span>
                    <template v-slot:action="{ attrs }">
                        <v-btn
                                :color="snackUpdatedColor"
                                text
                                v-bind="attrs"
                                @click="showSnackBar = false">
                            {{$t("fermer")}}
                        </v-btn>
                    </template>
                </v-snackbar>
            </div>
        </template>
    </div>

</template>

<script>
    /* eslint-disable */


    export default {

        label: "customsnackbar",
         props: ['snackbar','text','snackcolor','snackbBtnColor','snacktimeout'],
        data() {
            return {
              showSnackBar: this.snackbar
            }
        },
      computed:{
        //showSnackBar:function (){return this.snackbar},
        snackText:function (){return this.text},
        snackUpdatedColor:function (){return this.snackcolor},
        snackUpdatedBtnColor:function (){return this.snackbBtnColor},
        snackUpdatedTimeOut:function (){return this.snacktimeout},

      },
        methods: {


        }
    }
</script>

<style scoped>



</style>
